import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) return;
    
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formData = new FormData();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d4jv7ahgb9i7lkq8r6l0', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#FAF8F3] py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="bg-[#2C3E50] rounded-3xl px-8 md:px-12 py-12 md:py-16 relative overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12 relative z-10">
            <div>
              <h3 className="text-white text-2xl md:text-3xl font-bold mb-4 md:mb-6 leading-tight">
                お気軽に<br />ご相談ください
              </h3>
            </div>

            <div>
              <h4 className="text-white text-base md:text-lg font-bold mb-4 md:mb-6">サービス</h4>
              <ul className="space-y-2 md:space-y-3">
                <li>
                  <Link to="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                    生命保険
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                    医療保険
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                    自動車保険
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                    火災保険
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                    個人年金保険
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white text-base md:text-lg font-bold mb-4 md:mb-6">会社情報</h4>
              <ul className="space-y-2 md:space-y-3">
                <li>
                  <Link to="/about" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                    会社概要
                  </Link>
                </li>
                <li>
                  <Link to="/careers" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                    求人情報
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                    ブログ&新着情報
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm md:text-base">
                    お問い合わせ
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white text-base md:text-lg font-bold mb-3 md:mb-4 leading-tight">
                最新情報をお届けします
              </h4>
              <p className="text-gray-300 text-xs md:text-sm mb-3 md:mb-4">メールアドレスをご登録ください</p>
              <form id="newsletterForm" onSubmit={handleNewsletterSubmit} className="flex items-center gap-2" data-readdy-form>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="メールアドレス"
                  required
                  disabled={isSubmitting}
                  className="flex-1 bg-white/10 border border-white/20 rounded-full px-4 md:px-6 py-2.5 md:py-3 text-white placeholder-gray-400 focus:outline-none focus:border-white/40 text-xs md:text-sm"
                />
                <button 
                  type="submit"
                  disabled={isSubmitting}
                  className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer flex-shrink-0 disabled:opacity-50"
                >
                  <i className="ri-arrow-right-line text-lg md:text-xl text-[#2C3E50]"></i>
                </button>
              </form>
              {submitStatus === 'success' && (
                <p className="text-green-300 text-xs mt-2">登録ありがとうございます！</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-300 text-xs mt-2">エラーが発生しました</p>
              )}
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 text-center pb-8 pointer-events-none hidden md:block">
            <p className="text-[#3a4d5f] text-6xl lg:text-8xl font-black opacity-30" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              OKAYAMA HOKEN
            </p>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-300 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs md:text-sm text-center md:text-left">
            &copy; 2025 おかやま保険株式会社. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?origin=logo"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-gray-600 text-xs md:text-sm hover:text-[#FF9B7A] transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
